import { useEffect } from "react";
import { setMerchantOnboardingContext } from "@/lib/analytics/client";

export function useOnboardingAnalyticsContext(onboardingId: string) {
  useEffect(() => {
    setMerchantOnboardingContext(onboardingId);

    return () => setMerchantOnboardingContext(null);
  }, [onboardingId]);
}
